module.exports = __webpack_public_path__ + "img/1.0ad7d8e3.png";